module.exports = __webpack_public_path__ + "media/components/incentive/static/icon-check-5a026899542fd7ce5b55d2862983f432.svg";